import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query getActivityNotificationEvents {
  activityNotificationEvents {
    name
  }
}`;

function getActivityNotificationEvents() {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.activityNotificationEvents);
}

export default getActivityNotificationEvents;
